import { FeatureFlag, isFeatureEnabled } from "store/featureFlagsSlice"
import { useAppSelector } from "store/hooks"

import { ContractorsV2 } from "pages/vendor/ContractorsV2"

import { ContractorsV1 } from "./ContractorsV1"

export const Contractors = () => {
  const isEnterpriseDashboardEnabled = useAppSelector(isFeatureEnabled(FeatureFlag.EnterpriseDashboard))

  return isEnterpriseDashboardEnabled ? <ContractorsV2 /> : <ContractorsV1 />
}
